import ArrowDown from "./style"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function ArrowDownBlock(){
    return(
        <ArrowDown>
            <ExpandMoreIcon fontSize="large"/>
        </ArrowDown>
    )
}